import * as React from 'react';
import { makeObservable, observable, action, toJS } from 'mobx';

import { CardList, PageState } from '../types';
import { DEFAULT_PAGE } from '../constants';

class AppHandler {
  page: PageState = DEFAULT_PAGE;

  handlePayment: (cardId: number) => void = (cardId) => {
    console.warn('결제 이벤트가 지정되지 않았습니다.\nonClickPayment Prop을 지정해주세요.');
  };

  handleCancel: React.MouseEventHandler<HTMLElement> = (event) => {
    console.warn('결제 취소 이벤트가 지정되지 않았습니다.\nonClickCancel Prop을 지정해주세요.');
  };
  z;
  handleUpdated: (cardList: CardList) => void = (cardList) => {
    console.warn('카드 업데이트 이벤트가 지정되지 않았습니다.\nonCardUpdated Prop을 지정해주세요.');
  };

  constructor() {
    makeObservable(this, {
      page: observable,
      handlePayment: observable,
      handleCancel: observable,
      handleUpdated: observable,
      setAppLocation: action,
      setHandler: action,
      notifyCardUpdate: action,
    });
  }

  setAppLocation(page: PageState): void {
    this.page = page;
  }

  setHandler({ onClickPayment, onClickCancel, onUpdatedCardData }) {
    onClickPayment && (this.handlePayment = onClickPayment);
    onClickCancel && (this.handleCancel = onClickCancel);
    onUpdatedCardData && (this.handleUpdated = onUpdatedCardData);
  }

  notifyCardUpdate(cardList: CardList) {
    this.handleUpdated(toJS(cardList));
  }
}

export default new AppHandler();
